var lists_default = {
  "fontElementMap": "G8704",
  "orderedlist": "_89AK9",
  "bulletedlist": "e0ul2",
  "listItem": "_5EHX7"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
